<template>
	<div>
		<component :is="this.$store.state.auth.role" ></component>
	</div>
</template>

<script>
import Accountant from '../components/profile/Accountant'
import Client from '../components/profile/Client'
import Author from '../components/profile/Author'
import Manager from '../components/profile/Manager'
import Admin from '../components/profile/Admin'

export default {
	name: "Profile",
	components: {
		Accountant,
		Client,
		Author,
		Manager,
		Admin
	}
}
</script>

<style scoped>

</style>
